"use strict";

module.exports = function () {
  return Math.ceil(this.count / this.limit);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/computed/total-pages.js
// module id = 255
// module chunks = 0